import _ from 'lodash';

export const CustomTable = ({ columns = [], datas = [], height }) => {
    return (
        <div className="rounded-xl shadow border border-gray-200 overflow-x-auto">
            {/* Scrollable area with sticky header */}
            <div className={`${height ?? 'max-h-[300px]'} overflow-y-auto`}>
                <table className="min-w-full divide-y divide-gray-200 text-sm text-left">
                    <thead className="bg-gray-100 text-gray-700 uppercase tracking-wider">
                        <tr>
                            {_.map(columns, (col, index) => (
                                <th
                                    key={index}
                                    className="px-4 py-3 font-semibold sticky top-0 bg-gray-100 z-10"
                                >
                                    {col.label}
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-100">
                        {datas?.length > 0 ? (
                            _.map(datas, (data, rowIndex) => (
                                <tr key={rowIndex} className="hover:bg-gray-50 even:bg-gray-50">
                                    {_.map(columns, (col, colIndex) => (
                                        <td key={colIndex} className="px-4 py-2 whitespace-nowrap">
                                            {col.options
                                                ? col.options(_.get(data, col.name), data)
                                                : _.get(data, col.name, '-')}
                                        </td>
                                    ))}
                                </tr>
                            ))
                        ) : (
                            <td colSpan={columns?.length} className="px-4 py-2 text-base text-center whitespace-nowrap text-primary">
                                {('No Data Found')}
                            </td>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};
